/** buildTestCaseUrl が受け取るテスト結果（必要なフィールドのみ） */
export interface TestCaseUrlSource {
  testRunId?: string;
  testCaseDetail?: {
    workspace_id?: string;
    project_id?: string;
    testcase_id?: string;
  };
}

/**
 * TFACT のテストケース画面（テストラン実行画面のテストケース詳細）の URL を作る。
 *
 * workspace/project は必ず「表示中のテスト結果自身」（`testCaseDetail`）から取る。
 * 以前は localStorage の検索条件（`testresult-search-filters`）から取っていたため、
 * テストナビゲーターからダイレクトモード（`?workspace_id=..&project_id=..&result_id=..`）で
 * 開いた場合に前回の手動検索の workspace/project が混ざり、テストランと不整合な URL になって
 * TFACT が「このテストランは存在しません。」を返していた（tfact_user_request#538）。
 * ダイレクトモードはこのキーを書かないので、未検索のブラウザではリンク自体も消えていた。
 *
 * @param webBaseUrl TFACT の Web URL（`REACT_APP_SSTF_WEB_BASE_URL`）
 * @param apiTestResult 表示中のテスト結果（`transformApiTestResults` の結果）
 * @returns テストケース画面の URL。ID が欠けている場合は壊れた URL を作らず null
 */
export function buildTestCaseUrl(
  webBaseUrl: string | undefined,
  apiTestResult: TestCaseUrlSource | null | undefined
): string | null {
  if (!webBaseUrl || !apiTestResult) {
    return null;
  }

  const workspaceId = apiTestResult.testCaseDetail?.workspace_id;
  const projectId = apiTestResult.testCaseDetail?.project_id;
  const testRunId = apiTestResult.testRunId;
  const testCaseId = apiTestResult.testCaseDetail?.testcase_id;

  if (!workspaceId || !projectId || !testRunId || !testCaseId) {
    return null;
  }

  // 環境変数側に末尾スラッシュが入っていても `//` にならないようにする
  const base = webBaseUrl.replace(/\/+$/, "");

  return `${base}/${workspaceId}/${projectId}/testruns/${testRunId}/execution?t=d_testcase&k=${testCaseId}&dm=d&d_tab=`;
}
